import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from 'react';
import _ from 'lodash';
import { ListView } from '@tencent/ptp-fe-common';
import {
  Button,
  Select,
  Dialog,
} from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import { LeadsDataFilterShortcut } from '../../../consts/Common';

const STATUS_OPTIONS = [
  { value: 1, label: '授权' },
  { value: 2, label: '添加好友' },
  { value: 4, label: '有效沟通' },
  { value: 5, label: '报价' },
  { value: 3, label: '成单' },
  { value: 6, label: '无效' },
  { value: 7, label: '对方拉黑' },
];

const DIALOG_TYPE = {
  distribute: 'distribute',
  follow: 'follow',
};

export const TAB_TYPE = {
  company: 'company',
  team: 'team',
  personal: 'personal',
};

const FollowDialog = (props) => {
  const [status, setStatus] = useState('');

  useEffect(() => {
    setStatus('');
  }, [props.show]);

  const handleStatusChange = (e, val) => {
    setStatus(val);
  };

  const handleSubmit = () => {
    if (status === '') {
      alert('请选择客户状态');
      return;
    }
    props.onSubmit(status);
  };

  return (
    <Dialog
      show={props.show}
      title="跟进客户"
      type="simple"
      loading={props.loading}
      style={{ width: 350 }}
      onSubmit={handleSubmit}
      onCancel={props.onCancel}
      onClose={props.onCancel}
    >
      <br />
      <Select
        placeholder="客户状态"
        data={STATUS_OPTIONS}
        value={status}
        onChange={handleStatusChange}
      />
    </Dialog>
  );
};

const DistributeDialog = (props) => {
  const [owner, setOwner] = useState('');

  useEffect(() => {
    setOwner('');
  }, [props.show]);

  const handleOwnerChange = (e, val) => {
    setOwner(val);
  };

  const handleSubmit = () => {
    if (owner === '') {
      alert('请选择归属人');
      return;
    }
    props.onSubmit(owner);
  };

  return (
    <Dialog
      show={props.show}
      title="分配归属人"
      type="simple"
      loading={props.loading}
      style={{ width: 350 }}
      onSubmit={handleSubmit}
      onCancel={props.onCancel}
      onClose={props.onCancel}
    >
      <br />
      <Select
        placeholder="请选择归属人"
        data={props.ownerList}
        value={owner}
        onChange={handleOwnerChange}
      />
    </Dialog>
  );
};

const List = ({ mode }) => {
  const [operateItem, setOperateItem] = useState(null);
  const [dialogType, setDialogType] = useState(null);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [ownerList, setOwnerList] = useState([]);
  const lvRef = useRef(null);

  const getList = useCallback((params) => {
    return new Promise((res) => {
      RPCFactory.fansManagement.getPersonalWx(params)
        .done((data) => {
          const statusMap = {
            0: '未知',
            1: '授权',
            2: '添加好友',
            3: '成单',
            4: '有效沟通',
            5: '报价',
            6: '无效',
            7: '对方拉黑',
          };
          const listData = (data.entities || []).map((item) => ({
            ...item,
            _data: item,
            personalWechatStatus: statusMap[item.personalWechatStatus || 0],
          }));
          res({
            list: listData,
            page_info: {
              total_number: _.get(data, 'page_info.total_number', 0),
            },
          });
        })
        .fail((ret, msg) => {
          alert(msg);
          res({
            list: [],
            page_info: {
              total_number: 0,
            },
          });
        });
    });
  }, []);

  const reloadList = () => {
    if (!lvRef.current) return;
    const ES_DELAY = 1000;
    setTimeout(() => {
      // 防止延时时间内引用被修改为null（ct中存在该问题）
      if (!lvRef.current) return;
      lvRef.current.setBatchShow(false);
      lvRef.current.setSelectKeys([]);
      lvRef.current.loadList();
      handleDialogClose();
    }, ES_DELAY);
  };

  const getBatchIds = () => {
    if (operateItem) return [operateItem.leadsId];
    return lvRef.current.selectKeys;
  };

  const follow = (val) => {
    setDialogLoading(true);
    const params = {
      leadsIds: getBatchIds(),
      personalWechatStatus: val,
    };
    RPCFactory.fansManagement.updateFriendStatus(params)
      .done(reloadList)
      .fail((ret, msg) => {
        handleDialogClose();
        alert(msg);
      });
  };

  const distribute = (val) => {
    if (mode === TAB_TYPE.personal) return;
    setDialogLoading(true);
    const params = {
      leadsIds: getBatchIds(),
      ownerId: val,
    };
    RPCFactory.fansManagement.distributeFriend(params)
      .done(reloadList)
      .fail((ret, msg) => {
        handleDialogClose();
        alert(msg);
      });
  };

  const handleDialogClose = () => {
    setOperateItem(null);
    setDialogType(null);
    setDialogLoading(false);
  };

  const handleDialogChange = (type, item = null) => {
    setDialogType(type);
    setOperateItem(item);
  };

  const handleBatchFollow = () => {
    const selected = lvRef.current.selectKeys;
    if (selected.length < 1) {
      alert('请至少选择一个好友');
      return;
    }
    handleDialogChange(DIALOG_TYPE.follow);
  };

  const handleBatchDistribute = () => {
    const selected = lvRef.current.selectKeys;
    if (selected.length < 1) {
      alert('请至少选择一个好友');
      return;
    }
    handleDialogChange(DIALOG_TYPE.distribute);
  };

  const renderAvatar = useCallback((type, name, value, data) => {
    const url = data._data.avatar_url;
    const style = {
      width: 36,
      height: 36,
      borderRadius: 4,
      backgroundSize: '100%',
      backgroundImage: `url(${url})`,
    };
    return (<div style={style}></div>);
  }, []);

  const renderOption = useCallback((type, name, value, { _data: data }) => {
    const handleFollow = (e) => {
      e.preventDefault();
      handleDialogChange(DIALOG_TYPE.follow, data);
    };

    const handleDistribute = (e) => {
      e.preventDefault();
      handleDialogChange(DIALOG_TYPE.distribute, data);
    };

    return (
      <div>
        <a href="#" onClick={handleFollow} data-testid="follow">跟进客户</a>
        {mode !== TAB_TYPE.personal && (<a href="#" onClick={handleDistribute} data-testid="distribute">分配</a>)}
      </div>
    );
  }, []);

  const filterControls = useMemo(() => {
    const ruleNumber = {
      pattern: /^(\d+)?$/,
      message: 'ID只包含数字',
    };
    return [
      {
        name: 'nickname',
        title: '昵称',
        type: 'search',
      },
      mode !== TAB_TYPE.personal && {
        name: 'ownerIds',
        title: '归属人',
        type: 'select',
        config: { multiple: true, data: ownerList },
      },
      {
        name: 'personalWechatStatusList',
        title: '状态',
        type: 'select',
        config: { multiple: true, data: STATUS_OPTIONS },
      },
      {
        name: 'actionDate',
        title: '授权时间',
        type: 'date-picker',
        config: {
          type: 'range',
          longestRange: '365',
          useShortcut: true,
          shortcuts: LeadsDataFilterShortcut,
        },
      },
      {
        name: 'createDate',
        title: '创建时间',
        type: 'date-picker',
        config: {
          type: 'range',
          longestRange: '365',
          useShortcut: true,
          shortcuts: LeadsDataFilterShortcut,
        },
      },
      {
        name: 'advertiserId',
        title: '推广账户',
        type: 'search',
        rules: [ruleNumber],
      },
      {
        name: 'campaignName',
        title: '推广计划',
        type: 'search',
      },
      {
        name: 'campaignId',
        title: '推广计划ID',
        type: 'search',
        rules: [ruleNumber],
      },
      {
        name: 'adName',
        title: '广告名称',
        type: 'search',
      },
      {
        name: 'adId',
        title: '广告ID',
        type: 'search',
        rules: [ruleNumber],
      },
    ].filter(Boolean);
  }, [ownerList]);

  const showColumns = useMemo(() => {
    return [
      'avatar',
      'nickname',
      'ownerName',
      'personalWechatStatus',
      'actionTime',
      'createdTime',
      'advertiserId',
      'campaignName',
      'campaignId',
      'adName',
      'adId',
      'option',
    ];
  }, []);

  const columnsMap = useMemo(() => {
    return {
      avatar: { title: '头像', render: renderAvatar },
      nickname: { title: '昵称' },
      ownerName: { title: '归属人' },
      personalWechatStatus: { title: '状态' },
      actionTime: { title: '授权时间' },
      createdTime: { title: '信息创建时间' },
      advertiserId: { title: '推广账号' },
      campaignName: { title: '推广计划' },
      campaignId: { title: '推广计划ID' },
      adName: { title: '广告名称' },
      adId: { title: '广告ID' },
      option: { title: '操作', render: renderOption },
    };
  }, [renderAvatar, renderOption]);

  const tableColumns = useMemo(() => {
    return showColumns.map((name) => {
      if (!columnsMap[name]) return null;
      return { ...columnsMap[name], name };
    }).filter(Boolean);
  }, [columnsMap, showColumns]);

  const lvOptions = useCallback(() => {
    const defaultQueryValues = {};

    return {
      fetchConfig: {
        action: getList,
        $onError: window.alert,
        $onResponse(data) { return data; },
        $onRequest(params) {
          const scopeMap = {
            [TAB_TYPE.company]: 3,
            [TAB_TYPE.team]: 2,
            [TAB_TYPE.personal]: 1,
          };
          const obj = { ...params, queryScope: scopeMap[mode] };
          delete obj.page_size;
          delete obj.page;
          delete obj.actionDate;
          delete obj.createDate;
          obj.pageIndex = params.page;
          obj.pageSize = params.page_size;
          if (params.createDate) {
            obj.startCreatedDate = params.createDate.start_time;
            obj.endCreatedDate = params.createDate.end_time;
          }
          if (params.actionDate) {
            obj.startActionDate = params.actionDate.start_time;
            obj.endActionDate = params.actionDate.end_time;
          }
          return obj;
        },
      },
      toolbarconfig: null,
      filterConfig: {
        resetable: false,
        controls: filterControls,
        customConfigure: null,
        defaultValuesByKey: defaultQueryValues,
      },
      batchConfig: {
        left: (
          <div className="toolbar-right-group">
            <Button className="borderless" onClick={handleBatchFollow} data-testid="batch-follow">
              <i className="icon icon-batch" />
              <span>跟进客户</span>
            </Button>
            {
              mode !== TAB_TYPE.personal && (
                <Button className="borderless" onClick={handleBatchDistribute} data-testid="batch-distribute">
                  <i className="icon icon-batch" />
                  <span>分配</span>
                </Button>
              )
            }
          </div>
        ),
      },
      tableConfig: {
        defaultPageSize: 10,
        select: 'multiple',
        columns: tableColumns,
        rowKey: 'leadsId',
        onOptionalChange: null,
        optionalConfig: null,
      },
    };
  }, [getList, mode, filterControls, tableColumns]);

  useEffect(() => {
    if (mode === TAB_TYPE.personal) return;
    RPCFactory.employeeManage.getEmployees()
      .done((data) => {
        const list = (data.entities || []).map((item) => ({
          disabled: item.status !== 0 || item.leadsReceiveStatus === 0,
          value: item.userId,
          label: item.name,
        }));
        setOwnerList(list);
      });
  }, [mode]);

  return (
    <main id="main" className="main">
      <div className="page-pool">
        <div className="card borderd" style={{ paddingTop: 0 }}>
          <div className="datalist">
            <ListView
              className="lv"
              ref={lvRef}
              options={lvOptions}
            />
          </div>
        </div>
      </div>
      <FollowDialog
        show={dialogType === DIALOG_TYPE.follow}
        loading={dialogLoading}
        onCancel={handleDialogClose}
        onSubmit={follow}
      />
      <DistributeDialog
        show={dialogType === DIALOG_TYPE.distribute}
        loading={dialogLoading}
        ownerList={ownerList}
        onCancel={handleDialogClose}
        onSubmit={distribute}
      />
    </main>
  );
};

export default List;
